export default __webpack_public_path__ + "static/media/top-k-5-thumb.09462f3c.jpg";